import { render } from "./General.vue?vue&type=template&id=a3bf9856"
import script from "./General.vue?vue&type=script&lang=ts"
export * from "./General.vue?vue&type=script&lang=ts"
script.render = render

export default script